import { useEffect, useState } from "react";
import Nav from "./Nav";
import { Link } from "react-router-dom";
// import logo1 from '../../images/logo/logo@2x.png'
// import logo2 from '../../images/logo/logo@2x-white.png'
import logo1 from '../../images/logo/amr_logo.png'
import MobileNav from "./MobileNav";
import { checkUserIsLogin } from "../../APIs/APIHelperforWeb";
import { useNavigate } from "react-router-dom";
import { AMRDetail, BaseURL } from "../../APIs/APIUrls";
import { useClearLocalStorageAndRedirect } from "../../APIs/ValidateLocalStorage";

const AMR_CACHE_KEY = "AMRDetailforweb";
const AMR_CACHE_TS_KEY = "AMRDetailforweb_Timestamp";
const AMR_CACHE_TTL_MS = 5 * 60 * 1000;

export default function Header1({
  parentClass = "main-header header-fixed fixed-header",
}) {

  const navigate = useNavigate();
  const clearLocalStorageAndRedirect = useClearLocalStorageAndRedirect();
  const [isFixed, setIsFixed] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [photo, setPhoto] = useState("");

  const getDisplayablePhoto = (incomingPhoto) => {
    debugger;
    if (!incomingPhoto) return "";
    if (incomingPhoto.startsWith("data:") || incomingPhoto.startsWith("http")) {
      return incomingPhoto;
    }
    return `${BaseURL}${incomingPhoto}`;
  };

  const getStoredValue = (key) => {
    const rawValue = localStorage.getItem(key);
    if (rawValue == null) return "";
    try {
      const parsedValue = JSON.parse(rawValue);
      return typeof parsedValue === "string" ? parsedValue : rawValue;
    } catch {
      return rawValue;
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 60);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsLoggedIn(checkUserIsLogin());
    setUsername(getStoredValue("username"));
    setPhoto(getDisplayablePhoto(getStoredValue("photo")));
  }, []);

  const [amrDetail, setAmrDetail] = useState({
    ShortDescription: "",
    Address: "",
    ContactNo: "",
    Email: "",
    Facebook: "",
    Instagram: "",
    Youtube: "",
    Twitter: "",
  });

  const mapAMRDetail = (item) => ({
    ShortDescription: item?.ShortDescription ?? "",
    Address: item?.Address ?? "",
    ContactNo: item?.ContactNo ?? "",
    Email: item?.Email ?? "",
    Facebook: item?.Facebook ?? "",
    Instagram: item?.Instagram ?? "",
    Youtube: item?.Youtube ?? "",
    Twitter: item?.Twitter ?? "",
  });

  const fetchAMRDetailById = async (id = 1) => {
    try {
      const cachedAMRRaw = localStorage.getItem(AMR_CACHE_KEY);
      const cachedTsRaw = localStorage.getItem(AMR_CACHE_TS_KEY);
      const cachedAt = Number(cachedTsRaw);
      const isCacheValid =
        !Number.isNaN(cachedAt) && Date.now() - cachedAt < AMR_CACHE_TTL_MS;

      if (cachedAMRRaw && isCacheValid) {
        try {
          const cachedAMR = JSON.parse(cachedAMRRaw);
          if (cachedAMR && typeof cachedAMR === "object") {
            setAmrDetail(mapAMRDetail(cachedAMR));
            return;
          }
        } catch (error) {
          localStorage.removeItem(AMR_CACHE_KEY);
          localStorage.removeItem(AMR_CACHE_TS_KEY);
        }
      } else if (cachedAMRRaw && !isCacheValid) {
        localStorage.removeItem(AMR_CACHE_KEY);
        localStorage.removeItem(AMR_CACHE_TS_KEY);
      }

      const res = await fetch(AMRDetail + `GetAMRDetailByIdforweb/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (!res.ok) {
        throw new Error(`Failed with status ${res.status}`);
      }

      const data = await res.json();
      const dataSource = data?.data ?? data;
      const item = Array.isArray(dataSource) ? dataSource[0] : dataSource;

      if (!item) {
        throw new Error("No AMR detail found");
      }

      const mappedAMRDetail = mapAMRDetail(item);
      setAmrDetail(mappedAMRDetail);
      localStorage.setItem(AMR_CACHE_KEY, JSON.stringify(item));
      localStorage.setItem(AMR_CACHE_TS_KEY, String(Date.now()));
    } catch (error) {
      console.error("Error fetching header AMR detail:", error);
    }
  };

  useEffect(() => {
    fetchAMRDetailById(1);
  }, []);

  return (
    <header
      id="header"
      className={`${parentClass} ${isFixed ? "is-fixed" : ""}`}
    >
      {/* Header Lower */}
      <div className="header-lower">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner-header">
              <div className="inner-header-left">
                <div className="logo-box flex">
                  <div className="logo">
                    <Link to={`/`}>
                      <img
                        alt="logo"
                        width={166}
                        className="logo-1"
                        height={48}
                        src={logo1}
                        style={{ transform: "scale(1.1)" }}
                      />
                      <img
                        alt="logo"
                        width={166}
                        className="logo-2"
                        height={48}
                        src={logo1}
                      />
                    </Link>
                  </div>
                </div>
                <div className="nav-outer flex align-center">
                  {/* Main Menu */}
                  <nav className="main-menu show navbar-expand-md">
                    <div
                      className="navbar-collapse collapse clearfix"
                      id="navbarSupportedContent"
                    >
                      <ul className="navigation clearfix">
                        <Nav />
                      </ul>
                    </div>
                  </nav>
                  {/* Main Menu End*/}
                </div>
              </div>

              <div className="inner-header-right header-account">
                {
                  !isLoggedIn && (
                    <a
                      href="#modalLogin"
                      data-bs-toggle="modal"
                      className="tf-btn btn-line btn-login"
                    >
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.1251 5C13.1251 5.8288 12.7959 6.62366 12.2099 7.20971C11.6238 7.79576 10.8289 8.125 10.0001 8.125C9.17134 8.125 8.37649 7.79576 7.79043 7.20971C7.20438 6.62366 6.87514 5.8288 6.87514 5C6.87514 4.1712 7.20438 3.37634 7.79043 2.79029C8.37649 2.20424 9.17134 1.875 10.0001 1.875C10.8289 1.875 11.6238 2.20424 12.2099 2.79029C12.7959 3.37634 13.1251 4.1712 13.1251 5ZM3.75098 16.765C3.77776 15.1253 4.44792 13.5618 5.61696 12.4117C6.78599 11.2616 8.36022 10.6171 10.0001 10.6171C11.6401 10.6171 13.2143 11.2616 14.3833 12.4117C15.5524 13.5618 16.2225 15.1253 16.2493 16.765C14.2888 17.664 12.1569 18.1279 10.0001 18.125C7.77014 18.125 5.65348 17.6383 3.75098 16.765Z"
                          stroke="black"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Sign in
                    </a>
                  )
                }

                {/* {
                  isLoggedIn && (
                    <a
                      onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}
                      className="tf-btn btn-line btn-login"
                    >                      
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M19 23H11C10.4477 23 10 22.5523 10 22C10 21.4477 10.4477 21 11 21H19C19.5523 21 20 20.5523 20 20V4C20 3.44772 19.5523 3 19 3L11 3C10.4477 3 10 2.55229 10 2C10 1.44772 10.4477 1 11 1L19 1C20.6569 1 22 2.34315 22 4V20C22 21.6569 20.6569 23 19 23Z" fill="#2c2b2b"></path>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.48861 13.3099C1.83712 12.5581 1.83712 11.4419 2.48862 10.6902L6.66532 5.87088C7.87786 4.47179 10.1767 5.32933 10.1767 7.18074L10.1767 9.00001H16.1767C17.2813 9.00001 18.1767 9.89544 18.1767 11V13C18.1767 14.1046 17.2813 15 16.1767 15L10.1767 15V16.8193C10.1767 18.6707 7.87786 19.5282 6.66532 18.1291L2.48861 13.3099ZM4.5676 11.3451C4.24185 11.7209 4.24185 12.2791 4.5676 12.6549L8.1767 16.8193V14.5C8.1767 13.6716 8.84827 13 9.6767 13L16.1767 13V11L9.6767 11C8.84827 11 8.1767 10.3284 8.1767 9.50001L8.1767 7.18074L4.5676 11.3451Z" fill="#2c2b2b"></path>
                        </g>
                      </svg>
                      Log out
                    </a>
                  )
                } */}
                {
                  isLoggedIn ? (
                    <div className="header-account-dropdown header-account-desktop-only dropdown" style={{ position: "relative" }}>
                      <button
                        type="button"
                        className="box-avatar dropdown-toggle"
                        onClick={() => setAccountDropdownOpen((current) => !current)}
                        aria-expanded={accountDropdownOpen}
                        style={{ border: "none", background: "transparent", padding: 0, display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}
                      >
                        <div className="avatar avt-34 round">
                          {photo ? (
                            <img alt="profile" src={photo} width={38} height={38} />
                          ) : (
                            <svg
                              width={34}
                              height={34}
                              viewBox="0 0 34 34"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#header-avatar-clip)">
                                <path
                                  d="M10.0007 9.99947C10.9357 9.99947 11.8496 9.72222 12.627 9.20278C13.4044 8.68334 14.0103 7.94504 14.3681 7.08124C14.7259 6.21745 14.8196 5.26695 14.6372 4.34995C14.4547 3.43295 14.0045 2.59063 13.3434 1.92951C12.6823 1.26839 11.84 0.81816 10.923 0.635757C10.006 0.453354 9.05546 0.54697 8.19166 0.904766C7.32787 1.26256 6.58957 1.86847 6.07013 2.64586C5.55069 3.42326 5.27344 4.33723 5.27344 5.2722C5.27469 6.52556 5.77314 7.72723 6.65941 8.6135C7.54567 9.49976 8.74734 9.99821 10.0007 9.99947ZM10.0007 2.12068C10.624 2.12068 11.2333 2.30551 11.7516 2.65181C12.2699 2.9981 12.6738 3.4903 12.9123 4.06616C13.1509 4.64203 13.2133 5.27569 13.0917 5.88702C12.9701 6.49836 12.6699 7.05991 12.2292 7.50065C11.7884 7.9414 11.2269 8.24155 10.6155 8.36315C10.0042 8.48476 9.37054 8.42235 8.79468 8.18382C8.21881 7.94528 7.72661 7.54135 7.38032 7.02308C7.03403 6.50482 6.8492 5.89551 6.8492 5.2722C6.8492 4.43636 7.18123 3.63476 7.77225 3.04374C8.36328 2.45271 9.16488 2.12068 10.0007 2.12068Z"
                                  fill="white"
                                />
                                <path
                                  d="M10.0011 11.5762C8.12108 11.5783 6.31869 12.326 4.98934 13.6554C3.65999 14.9847 2.91224 16.7871 2.91016 18.6671C2.91016 18.876 2.99316 19.0764 3.14092 19.2242C3.28868 19.372 3.48908 19.455 3.69803 19.455C3.90699 19.455 4.10739 19.372 4.25515 19.2242C4.4029 19.0764 4.48591 18.876 4.48591 18.6671C4.48591 17.2044 5.06697 15.8016 6.10126 14.7673C7.13555 13.733 8.53835 13.1519 10.0011 13.1519C11.4638 13.1519 12.8666 13.733 13.9009 14.7673C14.9352 15.8016 15.5162 17.2044 15.5162 18.6671C15.5162 18.876 15.5992 19.0764 15.747 19.2242C15.8947 19.372 16.0951 19.455 16.3041 19.455C16.513 19.455 16.7134 19.372 16.8612 19.2242C17.009 19.0764 17.092 18.876 17.092 18.6671C17.0899 16.7871 16.3421 14.9847 15.0128 13.6554C13.6834 12.326 11.881 11.5783 10.0011 11.5762Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="header-avatar-clip">
                                  <rect width="18.9091" height="18.9091" fill="white" transform="translate(0.546875 0.544922)" />
                                </clipPath>
                              </defs>
                            </svg>
                          )}
                        </div>
                        <p className="name">
                          {username || "Account"}
                          <span className="icon icon-arr-down" />
                        </p>
                      </button>

                      {accountDropdownOpen ? (
                        <div
                          className="dropdown-menu show"
                          style={{
                            display: "block",
                            minWidth: "170px",
                            right: 0,
                            left: "auto",
                          }}
                        >
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => {
                              setAccountDropdownOpen(false);
                              navigate("/dashboard");
                            }}
                          >
                            Dashboard
                          </button>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => {
                              setAccountDropdownOpen(false);
                              clearLocalStorageAndRedirect();
                            }}
                          >
                            Logout
                          </button>
                        </div>
                      ) : null}
                    </div>
                  ) : null
                }

                {/* <div className="flat-bt-top">
                  <Link className="tf-btn primary" to={`/add-property`}>
                    <svg
                      width={21}
                      height={20}
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.625 14.375V17.1875C13.625 17.705 13.205 18.125 12.6875 18.125H4.5625C4.31386 18.125 4.0754 18.0262 3.89959 17.8504C3.72377 17.6746 3.625 17.4361 3.625 17.1875V6.5625C3.625 6.045 4.045 5.625 4.5625 5.625H6.125C6.54381 5.62472 6.96192 5.65928 7.375 5.72834M13.625 14.375H16.4375C16.955 14.375 17.375 13.955 17.375 13.4375V9.375C17.375 5.65834 14.6725 2.57417 11.125 1.97834C10.7119 1.90928 10.2938 1.87472 9.875 1.875H8.3125C7.795 1.875 7.375 2.295 7.375 2.8125V5.72834M13.625 14.375H8.3125C8.06386 14.375 7.8254 14.2762 7.64959 14.1004C7.47377 13.9246 7.375 13.6861 7.375 13.4375V5.72834M17.375 11.25V9.6875C17.375 8.94158 17.0787 8.22621 16.5512 7.69876C16.0238 7.17132 15.3084 6.875 14.5625 6.875H13.3125C13.0639 6.875 12.8254 6.77623 12.6496 6.60041C12.4738 6.4246 12.375 6.18614 12.375 5.9375V4.6875C12.375 4.31816 12.3023 3.95243 12.1609 3.6112C12.0196 3.26998 11.8124 2.95993 11.5512 2.69876C11.2901 2.4376 10.98 2.23043 10.6388 2.08909C10.2976 1.94775 9.93184 1.875 9.5625 1.875H8.625"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Submit Property
                  </Link>
                </div> */}
              </div>
              <div
                className="mobile-nav-toggler mobile-button"
                onClick={() => {
                  document.body.classList.add("mobile-menu-visible");
                }}
              >
                <span />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Header Lower */}
      {/* Mobile Menu  */}
      <div
        className="close-btn"
        onClick={() => {
          document.body.classList.remove("mobile-menu-visible");
        }}
      >
        <span className="icon flaticon-cancel-1" />
      </div>
      <div className="mobile-menu">
        <div className="menu-backdrop" />
        <nav className="menu-box">
          <div className="nav-logo">
            <Link to={`/`}>
              <img
                alt="nav-logo"
                width={174}
                height={44}
                src={logo1}
              />
            </Link>
          </div>
          <div className="bottom-canvas">
            {
              !isLoggedIn && (<div className="login-box flex align-center">
                <a href="#modalLogin" data-bs-toggle="modal" className="tf-btn primary">
                  Login
                </a>

                <a href="#modalRegister" data-bs-toggle="modal" className="tf-btn primary">
                  Register
                </a>
              </div>)
            }

            <div className="menu-outer">
              <MobileNav isLoggedIn={isLoggedIn} />
            </div>
            {/* <div className="button-mobi-sell">
              <Link className="tf-btn primary" to={`/add-property`}>
                Submit Property
              </Link>
            </div> */}
            <div className="mobi-icon-box">
              <div className="box d-flex align-items-center">
                <span className="icon icon-phone2" />
                <div>{amrDetail.ContactNo}</div>
              </div>
              <div className="box d-flex align-items-center">
                <span className="icon icon-mail" />
                <div>{amrDetail.Email}</div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      {/* End Mobile Menu */}
    </header >
  );
}
